<script setup>
import { provide, inject, onMounted, ref, onBeforeMount } from 'vue';
import TopBlock from './components/TopBlock';
import CreateBlock from "@/components/CreateBlock";
import FooterBlock from "@/components/FooterBlock";
import LessonsBlock from "@/components/LessonsBlock";

const pageType = inject('pageType');
const step = ref(1);
const isSharedPage = ref(false);
const sharedId = ref(undefined)
const createRef = ref(null);

const sendEvent = (eventName, parameterName, ...parameterValues) => {
  const eventObject = {
    event: 'DLevent',
    eventName,
    ParameterName1: parameterName,
  };

  parameterValues.forEach((value, index) => {
    eventObject[`ParameterValue${index + 1}`] = value;
  });

  dataLayer.push(eventObject);
};
const sendEventAlt = (eventName, ...parameters) => {
  const eventObject = {
    event: 'DLevent',
    eventName: eventName
  };

  parameters.forEach((param, index) => {
    eventObject[`ParameterName${index + 1}`] = param.name;
    eventObject[`ParameterValue${index + 1}`] = param.value;
  });
  
  dataLayer.push(eventObject);
};

provide('sendEvent', sendEvent);
provide('sendEventAlt', sendEventAlt);

const contentData = {
  prompt: {
    title: 'Узнайте как работать с нейросетями.<br/> Посмотрите курс из 3 видео-уроков!',
    createTitle: 'Давайте создадим картинку с&nbsp;помощью нейросети!',
    createText: 'Для этого нужно правильно написать промпт. <br/>Помните, как это делать? Выбирайте роль, задачу, детали и&nbsp;смотрите результат!',
    resultTitle: 'Отлично, у&nbsp;вас получилась настоящая картИИнка!',
    resultText: 'Чтобы закрепить знания о&nbsp;нейросетях, можно вернуться к&nbsp;видео или попробовать заново.',
    sharingPageTitle: 'Изображение от ИИ',
    sharingPageText: 'Посмотри уроки и&nbsp;попробуй создать своё изображение',
    sharingText: 'Посмотри уроки и попробуй создать своё изображение.',
    videos: [
      {title: 'Знакомимся с нейросетью', id: 'iZn4we7LzdkVZ6Haq6Qons'},
      {title: 'Учимся писать промпт', id: 'gBwxLHZsJy8CyRXcRWK1KW'},
      {title: 'Узнаём, что ещё могут нейросети', id: 'wvrPB2xQMt66JfxeXbB52a'}
    ],
    gameText: 'Посмотрели все уроки?<br/> Теперь попробуйте создать картинку<br/> с&nbsp;помощью нейросети!',
    buttonText: 'Создать картинку',
    footerNote: 'AI - Artificial intelligence - Искусственный интеллект'
  },
  character: {
    title: 'Узнайте как создать 3D Персонажа.<br/>Посмотрите курс из 3 видео-уроков!',
    createTitle: 'Время создать своего 3D&nbsp;персонажа!',
    createText: 'Помните основные этапы? Придумываем героя, затем моделируем и&nbsp;текстурируем его. Выбирайте разные варианты и&nbsp;смотрите, какие 3D персонажи получаются!',
    resultTitle: 'Какой хрутой 3D&nbsp;персонаж  получился!',
    resultText: 'В специальных 3D&nbsp;программах его можно анимировать, чтобы он&nbsp;двигался как настоящий! А&nbsp;пока вы&nbsp;можете вернуться к&nbsp;видео о&nbsp;3D анимации или&nbsp;попробовать заново.',
    sharingPageTitle: 'Хрутой персонаж',
    sharingPageText: 'Посмотри уроки и&nbsp;попробуй создать своего собственного персонажа',
    sharingText: 'Посмотри уроки и попробуй создать своего собственного персонажа.',
    videos: [
      {title: 'Узнаём, что такое 3D&nbsp;дизайн', id: '9WurVutPEpMa46MzQrR8VN'},
      {title: 'Учимся моделировать и&nbsp;текстурировать', id: '3LcWTqSG9GjFJGRg1KaGZn'},
      {title: 'Создаём 3D&nbsp;персонажа', id: 'bDDjyU6DpcLRrpLHb2cEz6'}
    ],
    gameText: 'Посмотрели все уроки?<br/>Теперь попробуйте создать<br/> 3D персонажа!',
    buttonText: 'Создать 3D персонажа',
    footerNote: '3D - Трёхмерный'
  },
  music: {
    title: 'Узнайте как создать музыкальный хит.<br/>Посмотрите курс из 3 видео-уроков!',
    createTitle: 'Давайте создадим музыкальный хит!',
    createText: 'Выбирайте мелодию, задавайте ритм, добавляйте луп и&nbsp;слушайте, что получается!',
    resultTitle: 'Отличный хит!',
    resultText: 'Чтобы закрепить знания о&nbsp;том, как создаются музыкальные хиты, можно вернуться к&nbsp;видео или посмотреть новые уроки.',
    sharingPageTitle: 'Хрутой трек',
    sharingPageText: 'Посмотри уроки и&nbsp;попробуй создать свой собственный трек',
    sharingText: 'Посмотри уроки и попробуй создать свой собственный трек.',
    videos: [
      {title: 'Узнаём, из&nbsp;чего состоит музыка', id: 'ouvQCDWH64xrnMFzSS5qEC'},
      {title: 'Создаём музыкальную дорожку', id: 'o5CHRMzfWzwp13XeXQs1A8'},
      {title: 'Записываем музыкальный хит', id: 'c2LCbZuY5wKS1kGjsmnkqM'}
    ],
    gameText: 'Посмотрели все уроки?<br/>Теперь попробуйте создать<br/> музыкальный хит!',
    buttonText: 'Создать хит',
  }
}

const scrollToTop = () =>  {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

const parseQueryParams = () => {
  const params = new URLSearchParams(window.location.search);
  isSharedPage.value = params.has('shared_id');
  if (isSharedPage.value) {
    sharedId.value = params.getAll('shared_id')[0];
    step.value = 2;
  }
};

onBeforeMount(() => {
  parseQueryParams();
})

onMounted(() => {
})

</script>

<template>
  <TopBlock :page-type="pageType" />
  <LessonsBlock
      :step="step"
      :page-type="pageType"
      :data="contentData[pageType]"
      v-show="step === 1"
      @buttonClick="step = 2; scrollToTop(); createRef.check(step)"
  />
  <CreateBlock
      v-show="step === 2"
      :page-type="pageType"
      :data="contentData[pageType]"
      @goBack="step = 1; scrollToTop(); isSharedPage = false; createRef.check(step);"
      :isSharing="isSharedPage"
      ref="createRef"
      :sharedId="sharedId"
  />
  <FooterBlock :note="contentData[pageType]['footerNote']"/>
</template>
